import { RoleId, Side, RoomState, GameState, CauseOfDeath } from '@/enum'

export const GAME_STATE = {
  [GameState.loading]: '読み込み中',
  [GameState.ready]: 'レディ',
  [GameState.firstNight]: '初夜',
  [GameState.day]: '昼',
  [GameState.voteStart]: '投票',
  [GameState.voteEnd]: '投票結果',
  [GameState.finalVoteReady]: '決選投票弁明',
  [GameState.finalVoteStart]: '決戦投票',
  [GameState.takeOther]: '道連れ選択',
  [GameState.night]: '夜',
  [GameState.gameover]: 'ゲームオーバー'
}

export const ROOM_STATE_LABEL = {
  [RoomState.loading]: '読み込み中',
  [RoomState.standBy]: 'スタンバイ',
  [RoomState.playing]: 'プレイ中'
}

export const CAUSE_OF_DEATH_MESSAGE = {
  [CauseOfDeath.mafia]: 'マフィアに襲撃された',
  [CauseOfDeath.killer]: '連続殺人犯の餌食になった',
  [CauseOfDeath.bomber]: '爆弾魔に爆破された',
  [CauseOfDeath.sniper]: '狙撃手に狙撃された',
  [CauseOfDeath.assassin]: '暗殺者に暗殺された',
  [CauseOfDeath.boy]: '少年に道連れにされた',
  [CauseOfDeath.eaten]: '蟹鍋にされて食べられてしまった',
  [CauseOfDeath.daughter]: 'ゴッドファーザーの娘の処刑に賛成したためゴッドファーザーにより殺害された',
  [CauseOfDeath.punished]: '投票により処刑された'
}

interface Role {
  name: string;
  code: RoleId;
  imageId: string;
  side: Side;
  mafia: boolean;
  weapon: boolean;
  openRoles: RoleId[];
  victoryConditions: string;
  ability: string;
  activeIn: {
    [GameState.firstNight]: boolean;
    [GameState.night]: boolean;
  };
  nightActionFollowMessage: string;
  nightActionMessage: string;
  takeOtherFollowMessage: string;
  winnerMessage: string;
}

export const MASTER_ROLE: {[key: string]: Role} = {
  [RoleId.people]: {
    name: '市民',
    code: RoleId.people,
    imageId: 'people',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '処刑されたときに遺言を残すことができる(フルクローズルールの場合は役職がオープンしないためこの能力は発動しない)',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '平和になった街で明るい未来を手に入れたのだ。それが例え一時のものだったとしても。'
  },
  [RoleId.nobleman]: {
    name: '貴族',
    code: RoleId.nobleman,
    imageId: 'nobleman',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '昼に処刑されない。処刑が決まった時にカードをオープンする。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '死と暴力の支配から解放された人々を次は金と権力の力で支配しようと目論むのだった。'
  },
  [RoleId.believers]: {
    name: '教会信者',
    code: RoleId.believers,
    imageId: 'believers',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [RoleId.believers],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '初日の夜に仲間の教会信者を知る。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '平和になった街で次の実権を握るため今日も布教に励むのだった。'
  },
  [RoleId.police]: {
    name: '警察',
    code: RoleId.police,
    imageId: 'police',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '毎晩起きてひとりを指定し、マフィア陣営かどうかを知る。',
    activeIn: {
      [GameState.firstNight]: true,
      [GameState.night]: true
    },
    nightActionFollowMessage: '取り調べる対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を取り調べますか？',
    winnerMessage: '平和になった街で今宵も娼婦と踊るのだった。'
  },
  [RoleId.investigator]: {
    name: '捜査員',
    code: RoleId.investigator,
    imageId: 'investigator',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '毎晩起きてひとりを指定し、武器の有無を知る。',
    activeIn: {
      [GameState.firstNight]: true,
      [GameState.night]: true
    },
    nightActionFollowMessage: '捜査する対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を捜査しますか？',
    winnerMessage: '平和になったはずの街で凶器を持つ者の噂を聞き、今夜も捜査に乗り出すのだった。'
  },
  [RoleId.doctor]: {
    name: '医者',
    code: RoleId.doctor,
    imageId: 'doctor',
    side: Side.people,
    mafia: false,
    weapon: true,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '毎晩起きてひとりを指定し、殺害から守る。爆弾魔から守ることはできない。また、自分を守ること、同じ人を連日守ることはできない。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '守る対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を守りますか？',
    winnerMessage: '今宵の手術を成功させるか失敗させるか思案する。その手には連続殺人犯の凶器と同じメスが握られていた。'
  },
  [RoleId.dancer]: {
    name: '踊り子',
    code: RoleId.dancer,
    imageId: 'dancer',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '毎晩起きてひとりを指定し、行動を封じる。同じ人を連日指定することはできない。娼婦あるいは踊り子を指定した場合能力は発動しない',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '誘惑する対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰と踊りますか？',
    winnerMessage: '平和になった街で次の身の振り方を考える。先輩がいい仕事を紹介してくれるらしい。踊り子は夜の歓楽街に消えていった。'
  },
  [RoleId.sniper]: {
    name: '狙撃手',
    code: RoleId.sniper,
    imageId: 'sniper',
    side: Side.people,
    mafia: false,
    weapon: true,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '一定回数夜に一人を殺害することができる。弾がなくなった次の夜以降は武器なし判定となる。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '狙撃する対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を撃ちますか？',
    winnerMessage: '銃を置き、明日からは普通の高校生として学校に通うのだった。'
  },
  [RoleId.survivor]: {
    name: 'サバイバー',
    code: RoleId.survivor,
    imageId: 'survivor',
    side: Side.neutrality,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: 'いずれかの陣営が勝利したときに生き残っていると一緒に勝利',
    nightActionFollowMessage: '防弾チョッキを着るかどうか選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '防弾チョッキを着ますか？',
    ability: '一定回数防弾チョッキを着て夜の殺害を防ぐ。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    winnerMessage: '街の情報を別の組織に売り、手にしたお金で遠くの国へ。そこで静かに暮らすのだった。'
  },
  [RoleId.cinderellaGirl]: {
    name: '新人女優',
    code: RoleId.cinderellaGirl,
    imageId: 'cinderellaGirl',
    side: Side.neutrality,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: 'いずれかの陣営が勝利したときに処刑あるいは殺害されていれば一緒に勝利',
    ability: '特になし',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '新聞の一面を飾るほど有名になった。彼女はまだ気付いていない。その成功を妬む女の存在を。'
  },
  [RoleId.mafia]: {
    name: 'マフィア',
    code: RoleId.mafia,
    imageId: 'mafia',
    side: Side.mafiaLeader,
    mafia: true,
    weapon: true,
    openRoles: [RoleId.mafia, RoleId.godfather, RoleId.godfatherAndMafia],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: '毎晩起きて幹部以外のプレイヤーを殺害する。マフィアが複数いても全員で殺せるのは一人。マフィアとゴッドファーザーを知る。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '今夜のターゲットを選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰をターゲットにしますか？マフィア全員が選んだ中から一人が撃たれます。',
    winnerMessage: '明日も金と暴力で人々を支配する。ここは無法者の街となったのだ。'
  },
  [RoleId.godfather]: {
    name: 'ゴッドファーザー',
    code: RoleId.godfather,
    imageId: 'godfather',
    side: Side.mafiaLeader,
    mafia: false,
    weapon: true,
    openRoles: [RoleId.mafia],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: 'マフィアがいる限り市民判定かつ、夜は殺害されない(ただし爆弾魔の殺害は防げない)。マフィアが全滅した場合自分がマフィアとなる。マフィアを知る。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '今夜のターゲットを選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰をターゲットにしますか？',
    winnerMessage: 'ファミリーを従え、街の王として君臨した。それでも娘の前ではただの父親でありたいのだった。'
  },
  [RoleId.godfatherAndMafia]: {
    name: 'ゴッドファーザー',
    code: RoleId.godfatherAndMafia,
    imageId: 'godfather',
    side: Side.mafiaLeader,
    mafia: true,
    weapon: true,
    openRoles: [RoleId.mafia],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: 'マフィアがいる限り市民判定かつ、夜は殺害されない(ただし爆弾魔の殺害は防げない)。マフィアが全滅した場合自分がマフィアとなる。マフィアを知る。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '今夜のターゲットを選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰をターゲットにしますか？',
    winnerMessage: 'ファミリーを従え、街の王として君臨した。それでも娘の前ではただの父親でありたいのだった。'
  },
  [RoleId.daughter]: {
    name: 'ゴッドファーザーの娘',
    code: RoleId.daughter,
    imageId: 'daughter',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '娘が処刑されるときに娘に投票している全員(GF含む)が死亡する',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '父親がマフィアのドンであったことを、その死に際まで知らなかった。彼女は笑顔を忘れ、復讐の鬼となったのだった。'
  },
  [RoleId.prostitute]: {
    name: '娼婦',
    code: RoleId.prostitute,
    imageId: 'prostitute',
    side: Side.mafia,
    mafia: true,
    weapon: false,
    openRoles: [RoleId.godfather],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: '毎晩起きてひとりを指定し、行動を封じる。同じ人を連日指定することはできない。娼婦あるいは踊り子を指定した場合能力は発動しない。ゴッドファーザーを知る。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '誘惑する対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰をお客に取りますか？',
    winnerMessage: 'マフィアが支配する街で今夜も客を待つ。胡散臭い笑顔の客から銃を受け取り、この生活を終わらせるためにゴッドファーザーの元へと向かった。'
  },
  [RoleId.traitor]: {
    name: '裏切り者',
    code: RoleId.traitor,
    imageId: 'traitor',
    side: Side.mafia,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: '特になし',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '信じられる者も信じる者もいないこの街で、今度はマフィアを裏切るのだろう。'
  },
  [RoleId.trickster]: {
    name: 'ペテン師',
    code: RoleId.trickster,
    imageId: 'trickster',
    side: Side.mafia,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: '毎晩起きてひとりを指定し、その夜だけマフィア陣営・武器あり判定にする',
    activeIn: {
      [GameState.firstNight]: true,
      [GameState.night]: true
    },
    nightActionFollowMessage: 'ペテンに掛ける対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を騙しますか？',
    winnerMessage: 'ドンの女が銃を欲しがっているという情報を得る。普段は空の弾倉に一つだけ弾を込め、夜の街に消えていった。'
  },
  [RoleId.bomber]: {
    name: '爆弾魔',
    code: RoleId.bomber,
    imageId: 'bomber',
    side: Side.outlaw,
    mafia: false,
    weapon: true,
    openRoles: [],
    victoryConditions: '生存者がアウトローのみとなると勝利',
    ability: '毎晩起きて爆弾の設置か、設置済みの爆弾をすべて起爆することのどちらかを行う。初めて狙われた夜は殺害されない。',
    activeIn: {
      [GameState.firstNight]: true,
      [GameState.night]: true
    },
    nightActionFollowMessage: '設置済みの爆弾を起爆するか、爆弾を設置する対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰に爆弾を設置しますか？',
    winnerMessage: '今夜も新しい爆弾の開発にいそしみ、それを抱いて眠りにつく。明日はどこに設置しようかと夢を見る。'
  },
  [RoleId.killer]: {
    name: '連続殺人犯',
    code: RoleId.killer,
    imageId: 'killer',
    side: Side.outlaw,
    mafia: false,
    weapon: true,
    openRoles: [],
    victoryConditions: '生存者がアウトローのみとなると勝利',
    ability: '毎晩起きて一人を殺害することができる。夜は殺害されない。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '今夜のターゲットを選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰を獲物にしますか？',
    winnerMessage: '次の獲物を探して誰もいなくなった街を去った。'
  },
  [RoleId.boy]: {
    name: '少年',
    code: RoleId.boy,
    imageId: 'boy',
    side: Side.people,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: 'あなたは昼に追放されたとき、または襲撃されて死亡した夜の翌朝にカードを公開し、誰か一人を道連れにする。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '道連れにする対象を選んでください。',
    nightActionMessage: '',
    winnerMessage: '平和になった街で、行方不明になった父を探す日々を送ることになる。'
  },
  [RoleId.assassin]: {
    name: '暗殺者',
    code: RoleId.assassin,
    imageId: 'assassin',
    side: Side.mafia,
    mafia: true,
    weapon: true,
    openRoles: [],
    victoryConditions: '中立・アウトロー全員死亡かつ生存者の半数以上がマフィア幹部となると勝利',
    ability: 'あなたは昼に追放されたとき、または襲撃されて死亡した夜の翌朝にカードを公開し、誰か一人を道連れにする。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '道連れにする対象を選んでください。',
    nightActionMessage: '',
    winnerMessage: '銃とナイフの手入れを終えて月を見上げる。次のターゲットは、あなた...。'
  },
  [RoleId.pickpocket]: {
    name: 'スリ',
    code: RoleId.pickpocket,
    imageId: 'pickpocket',
    side: Side.outlaw,
    mafia: false,
    weapon: false,
    openRoles: [],
    victoryConditions: '一定数を盗んだ翌朝に生き残っていれば勝利',
    ability: '毎晩一人の武器を盗み、その晩の武器の能力を失わせる。盗みに成功した夜は武器あり判定となり、盗まれた者は武器なし判定となる。ペテンにかけられた人からも盗める。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: true
    },
    nightActionFollowMessage: '武器を盗む対象を選んでください。',
    takeOtherFollowMessage: '',
    nightActionMessage: '今夜は誰から盗みますか？',
    winnerMessage: '今日も盗みを働いては売りさばく。親を失った子供たちのために。'
  },
  [RoleId.crab]: {
    name: '上海蟹',
    code: RoleId.crab,
    imageId: 'crab',
    side: Side.people,
    openRoles: [],
    mafia: false,
    weapon: false,
    victoryConditions: '中立・アウトロー・マフィア幹部全員死亡で勝利',
    ability: '夜時間にあなたに対し何らかの行動があった場合、あなたは翌朝に脱落する。あなたに対し行動したプレイヤーは翌日の議論で「蟹がおいしかったので...」しか発言ができない。',
    activeIn: {
      [GameState.firstNight]: false,
      [GameState.night]: false
    },
    nightActionFollowMessage: '',
    takeOtherFollowMessage: '',
    nightActionMessage: '',
    winnerMessage: '危うくカニ鍋にされる危機を乗り越え、上海の海へと帰って行った。'
  }
}

export const REGULATION_ROLE: {[key: string]: Role} = {
  [RoleId.people]: MASTER_ROLE[RoleId.people],
  [RoleId.nobleman]: MASTER_ROLE[RoleId.nobleman],
  [RoleId.believers]: MASTER_ROLE[RoleId.believers],
  [RoleId.police]: MASTER_ROLE[RoleId.police],
  [RoleId.investigator]: MASTER_ROLE[RoleId.investigator],
  [RoleId.doctor]: MASTER_ROLE[RoleId.doctor],
  [RoleId.dancer]: MASTER_ROLE[RoleId.dancer],
  [RoleId.sniper]: MASTER_ROLE[RoleId.sniper],
  [RoleId.survivor]: MASTER_ROLE[RoleId.survivor],
  [RoleId.cinderellaGirl]: MASTER_ROLE[RoleId.cinderellaGirl],
  [RoleId.mafia]: MASTER_ROLE[RoleId.mafia],
  [RoleId.godfather]: MASTER_ROLE[RoleId.godfather],
  [RoleId.daughter]: MASTER_ROLE[RoleId.daughter],
  [RoleId.prostitute]: MASTER_ROLE[RoleId.prostitute],
  [RoleId.traitor]: MASTER_ROLE[RoleId.traitor],
  [RoleId.trickster]: MASTER_ROLE[RoleId.trickster],
  [RoleId.bomber]: MASTER_ROLE[RoleId.bomber],
  [RoleId.killer]: MASTER_ROLE[RoleId.killer],
  [RoleId.boy]: MASTER_ROLE[RoleId.boy],
  [RoleId.assassin]: MASTER_ROLE[RoleId.assassin],
  [RoleId.pickpocket]: MASTER_ROLE[RoleId.pickpocket],
  [RoleId.crab]: MASTER_ROLE[RoleId.crab],
  [RoleId.pickpocket]: MASTER_ROLE[RoleId.pickpocket],
  [RoleId.crab]: MASTER_ROLE[RoleId.crab],
}

Object.freeze(GAME_STATE)
Object.freeze(ROOM_STATE_LABEL)
